import { savedI18nStorageKey } from '@/constants'
import { createI18n } from 'vue-i18n'
import en from './en'
import zhTW from './zh-TW'
import zendesk from '@/libs/zendesk'
const messages = {
  'zh-TW': zhTW,
  en
}

let lang = 'en';

['zh-TW', 'en'].forEach(item => {
  if (window.localStorage.getItem(savedI18nStorageKey) === item) {
    lang = item
  }
})

zendesk.setLocale(lang.includes('zh-TW') ? 'zh-TW' : 'en')

// 通过选项创建 VueI18n 实例
export default createI18n({
  locale: lang, // 设置地区
  messages // 设置地区信息
})
